module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/bg_equipment-93c1a525af21e8bca4c7bb2cd0654567.png";